// Coordonnées GPS approximatives des principales villes de Madagascar
// Format: [longitude, latitude] (décimal)

export const CITY_COORDS = {
  // === Capitales & grandes villes ===
  "Antananarivo": [47.51, -18.87],
  "Toamasina (Tamatave)": [49.40, -18.15],
  "Antsirabe": [47.03, -19.87],
  "Fianarantsoa": [47.09, -21.45],
  "Mahajanga": [46.32, -15.72],
  "Antsiranana (Diego-Suarez)": [49.29, -12.27],
  "Toliara (Tuléar)": [43.67, -23.35],
  "Tolagnaro (Fort-Dauphin)": [46.99, -25.03],
  "Morondava": [44.28, -20.29],

  // === Nord ===
  "Nosy Be": [48.27, -13.33],
  "Hell-Ville": [48.27, -13.41],
  "Ambanja": [48.45, -13.68],
  "Ambilobe": [49.05, -13.20],

  // === SAVA ===
  "Sambava": [50.17, -14.27],
  "Antalaha": [50.28, -14.90],
  "Andapa": [49.65, -14.65],
  "Vohemar": [50.00, -13.37],

  // === Analanjirofo ===
  "Fenerive-Est": [49.40, -17.38],
  "Maroantsetra": [49.74, -15.44],
  "Mananara Nord": [49.77, -16.17],
  "Sainte-Marie (Nosy Boraha)": [49.85, -17.09],
  "Soanierana-Ivongo": [49.60, -16.92],
  "Vavatenina": [49.18, -17.47],

  // === Atsinanana ===
  "Brickaville": [49.07, -18.82],
  "Vatomandry": [48.98, -19.33],
  "Mahanoro": [48.80, -19.90],

  // === Alaotra Mangoro ===
  "Ambatondrazaka": [48.42, -17.85],
  "Moramanga": [48.22, -18.95],
  "Amparafaravola": [48.23, -17.57],

  // === Analamanga (annexe Antananarivo) ===
  "Ambohidratrimo": [47.42, -18.83],
  "Anjozorobe": [47.88, -18.40],
  "Manjakandriana": [47.80, -18.92],
  "Ankazobe": [47.12, -18.32],

  // === Itasy ===
  "Miarinarivo": [46.90, -19.00],
  "Arivonimamo": [47.18, -19.00],
  "Soavinandriana": [46.73, -19.18],

  // === Bongolava ===
  "Tsiroanomandidy": [46.05, -18.77],
  "Fenoarivobe": [46.68, -18.43],

  // === Vakinankaratra ===
  "Ambatolampy": [47.43, -19.37],
  "Betafo": [46.85, -19.83],
  "Faratsiho": [46.95, -19.40],

  // === Amoron'i Mania ===
  "Ambositra": [47.25, -20.53],
  "Fandriana": [47.38, -20.23],

  // === Haute Matsiatra ===
  "Ambalavao": [46.93, -21.83],
  "Ambohimahasoa": [47.22, -21.12],

  // === Vatovavy / Fitovinany ===
  "Manakara": [48.02, -22.15],
  "Mananjary": [48.34, -21.22],
  "Nosy Varika": [48.53, -20.58],

  // === Atsimo Atsinanana ===
  "Farafangana": [47.83, -22.82],
  "Vangaindrano": [47.60, -23.35],
  "Vondrozo": [47.30, -22.82],

  // === Ihorombe ===
  "Ihosy": [46.13, -22.40],
  "Ivohibe": [46.88, -22.48],

  // === Menabe ===
  "Belo-sur-Tsiribihina": [44.55, -19.70],
  "Miandrivazo": [45.47, -19.52],
  "Mahabo": [44.67, -20.37],
  "Manja": [44.32, -21.43],

  // === Atsimo Andrefana ===
  "Morombe": [43.37, -21.75],
  "Sakaraha": [44.53, -22.90],
  "Betioky Sud": [44.37, -23.72],
  "Ampanihy Ouest": [44.75, -24.70],

  // === Androy ===
  "Ambovombe-Androy": [46.08, -25.18],
  "Beloha": [45.05, -25.17],
  "Tsihombe": [45.48, -25.32],

  // === Anosy ===
  "Amboasary Atsimo": [46.40, -25.03],
  "Betroka": [46.10, -23.27],

  // === Boeny ===
  "Marovoay": [46.63, -16.10],
  "Mitsinjo": [45.87, -16.02],

  // === Sofia ===
  "Antsohihy": [47.98, -14.87],
  "Mandritsara": [48.83, -15.83],
  "Befandriana-Nord": [48.50, -15.25],
  "Mampikony": [47.63, -16.07],
  "Boriziny (Port-Bergé)": [47.62, -15.55],
  "Analalava": [47.75, -14.63],
  "Bealanana": [48.67, -14.53],

  // === Betsiboka ===
  "Maevatanana": [46.83, -16.95],
  "Tsaratanana": [47.63, -16.78],

  // === Melaky ===
  "Maintirano": [44.03, -18.07],
  "Antsalova": [44.62, -18.68],
  "Besalampy": [44.48, -16.75],

  // === Quartiers Antananarivo ===
  "Analakely": [47.52, -18.91],
  "Isotry": [47.51, -18.92],
  "Ankorondrano": [47.52, -18.88],
  "Ivandry": [47.54, -18.86],
  "Ampitatafika": [47.48, -18.95],
  "Ivato": [47.48, -18.80],
  "Ivato Aéroport": [47.48, -18.80],
  "Tanjombato": [47.52, -18.96],
  "Alasora": [47.57, -18.93],
};

// Projection simple en SVG coords pour viewBox 600×1000
// (Madagascar bounds: lng 43-51, lat -26 à -12)
export const projectMadagascar = ([lng, lat]) => {
  const x = ((lng - 43) / 8) * 600;
  const y = ((-lat - 12) / 14) * 1000;
  return [x, y];
};

// Contour simplifié de Madagascar (liste de points [lng, lat])
export const MADAGASCAR_COASTLINE = [
  // Nord (Cap d'Ambre) puis côte EST vers le sud
  [49.40, -12.00], [49.50, -12.35], [49.80, -12.80], [49.60, -13.30],
  [49.75, -14.00], [50.10, -14.50], [50.30, -15.00], [50.45, -15.70],
  [50.50, -16.00], [50.25, -16.55], [49.80, -17.00], [49.65, -17.70],
  [49.45, -18.15], [49.20, -19.00], [49.00, -19.80], [48.70, -20.70],
  [48.50, -21.80], [48.10, -22.50], [47.85, -23.30], [47.55, -24.40],
  [47.15, -25.05], [46.50, -25.35], [45.65, -25.63], [44.90, -25.35],
  // Côte SUD vers OUEST puis NORD
  [44.15, -25.00], [43.85, -24.60], [43.60, -23.80], [43.45, -22.95],
  [43.40, -22.40], [43.55, -21.70], [43.90, -21.00], [44.15, -20.30],
  [44.05, -19.60], [44.00, -18.80], [44.20, -18.10], [44.55, -17.20],
  [44.95, -16.50], [45.50, -15.95], [46.10, -15.70], [46.60, -15.50],
  [47.00, -15.20], [47.40, -14.70], [47.80, -14.00], [48.20, -13.60],
  [48.60, -13.10], [49.05, -12.50], [49.40, -12.00],
];
